import React, { useEffect, useState } from 'react';
import QRCodeLib from 'qrcode';

const QRCode = ({ value, size = 200 }) => {
  const [dataUrl, setDataUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!value) return;

    QRCodeLib.toDataURL(value, {
      width: size,
      margin: 2,
      color: { dark: '#1c2544', light: '#ffffff' },
      errorCorrectionLevel: 'M'
    })
      .then(url => setDataUrl(url))
      .catch(err => {
        console.error('QR oluşturulamadı:', err);
        setError(true);
      });
  }, [value, size]);

  if (error) {
    return (
      <div style={{
        width: size, height: size, display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: 'var(--bg-surface-2)', border: '1px solid var(--border-default)',
        borderRadius: 8, fontSize: 13, color: 'var(--fg-secondary)', textAlign: 'center', padding: 16
      }}>
        QR kod yüklenemedi.<br />Lütfen anahtarı manuel girin.
      </div>
    );
  }

  if (!dataUrl) {
    return (
      <div style={{
        width: size, height: size, display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: 'var(--bg-surface-2)', border: '1px solid var(--border-default)',
        borderRadius: 8, fontSize: 13, color: 'var(--fg-tertiary)'
      }}>
        Yükleniyor...
      </div>
    );
  }

  return (
    // V71 — QR tarayıcılar için beyaz zemin her iki temada da korunur
    <div className="keep-light" style={{
      display: 'inline-block', padding: 12, background: '#fff',
      border: '1px solid #e2e5f1', borderRadius: 8
    }}>
      <img src={dataUrl} alt="QR Code" width={size} height={size} style={{ display: 'block' }} />
    </div>
  );
};

export default QRCode;
